class vbTabs extends HTMLElement {
  constructor () {
    super()

    this.tabs = []
    this.tabs = this.querySelectorAll('[role=tab]')
    this.tabsArr = [...this.tabs]
    this.tabpanels = []
    this.firstTab = null
    this.lastTab = null

    this.tabs.forEach(tab => {
      const tabcontrols = `#${tab.getAttribute('aria-controls')}`
      const tabpanel = this.querySelector(tabcontrols)
      tab.tabIndex = -1
      tab.setAttribute('aria-selected', 'false')
      this.tabpanels.push(tabpanel)
      tab.addEventListener('keydown', this.onKeydown.bind(this))
      tab.addEventListener('click', this.onClick.bind(this))

      if (!this.firstTab) {
        this.firstTab = tab
      }
      this.lastTab = tab
    })

    this.setSelectedTab(this.firstTab, false)
  }

  setSelectedTab (currentTab, setFocus) {
    if (typeof setFocus !== 'boolean') {
      setFocus = true
    }

    this.tabs.forEach((tab, i) => {
      if (currentTab === tab) {
        tab.setAttribute('aria-selected', 'true')
        tab.removeAttribute('tabindex')
        this.tabpanels[i].classList.remove('is-hidden')
        if (setFocus) {
          tab.focus()
        }
        if (this.tabpanels[i].querySelector('.tabpanel-content').scrollHeight > 110) {
          this.tabpanels[i].classList.add('expandable')
        }
      } else {
        tab.setAttribute('aria-selected', 'false')
        tab.tabIndex = -1
        this.tabpanels[i].classList.add('is-hidden')
      }
    })
  }

  setSelectedToPreviousTab (currentTab) {
    let index
    if (currentTab === this.firstTab) {
      this.setSelectedTab(this.lastTab)
    } else {
      index = this.tabsArr.indexOf(currentTab)
      this.setSelectedTab(this.tabs[index - 1])
    }
  }

  setSelectedToNextTab (currentTab) {
    let index
    if (currentTab === this.lastTab) {
      this.setSelectedTab(this.firstTab)
    } else {
      index = this.tabsArr.indexOf(currentTab)
      this.setSelectedTab(this.tabs[index + 1])
    }
  }

  onKeydown (event) {
    const tgt = event.currentTarget
    let flag = false
    switch (event.key) {
      case 'ArrowLeft':
        this.setSelectedToPreviousTab(tgt)
        flag = true
        break
      case 'ArrowRight':
        this.setSelectedToNextTab(tgt)
        flag = true
        break
      case 'Home':
        this.setSelectedTab(this.firstTab)
        flag = true
        break
      case 'End':
        this.setSelectedTab(this.lastTab)
        flag = true
        break
      default:
        break
    }

    if (flag) {
      event.stopPropagation()
      event.preventDefault()
    }
  }

  onClick (event) {
    this.setSelectedTab(event.currentTarget)
  }
}

customElements.define('vb-tabs', vbTabs)

class vbTableConversion extends HTMLElement {
  constructor () {
    super()

    this.switches = this.querySelectorAll('.table-convert_switch')

    this.switches.forEach(
      (switcher) => switcher.addEventListener('change', this.switchChange.bind(this)),
    )
  }

  switchChange (event) {
    if (event.target.getAttribute('data-metric') === 'in') {
      this.classList.remove('cm')
      this.classList.add('in')
    } else {
      this.classList.remove('in')
      this.classList.add('cm')
    }
  }
}

customElements.define('vb-table-conversion', vbTableConversion)
